import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import CreatableSelect from "react-select/creatable";
import {isEqual} from "lodash";
import {components} from "react-select";
import {useTranslation} from "react-i18next";

const EmailSelect = (props) => {
  const { t } = useTranslation('client_mail_form');
  const selectRef = useRef();

  const normalizeValue = (val) => {
    if (val == null) {
      return [];
    }
    if (Array.isArray(val)) {
      return val;
    }
    if (typeof val === 'string') {
      return [val];
    }
    return [];
  };

  const [internalValue, setInternalValue] = useState(() => normalizeValue(props.value, props.isMulti));

  useEffect(() => {
    const normalized = normalizeValue(props.value, props.isMulti);
    if (!isEqual(internalValue, normalized)) {
      setInternalValue(normalized);
    }
  }, [props.value, props.isMulti]);

  const getOptions = () => {
    return internalValue.map(email => ({
      value: email,
      label: email
    }));
  };

  const handleChange = (selected) => {
    const newValues = selected ? selected.map(item => item.value) : [];

    setInternalValue(newValues);

    if (props.isMulti) {
      props.onChange(newValues);
    } else {
      props.onChange(newValues.length > 0 ? newValues[0] : null);
    }
  };

  const handleCreate = (inputValue) => {
    const newValues = [...internalValue, inputValue];
    setInternalValue(newValues);

    if (props.isMulti) {
      props.onChange(newValues);
    } else {
      props.onChange(inputValue);
    }
  };

  const valueForSelect = () => {
    const options = getOptions();
    if (props.isMulti) {
      return options;
    } else {
      return options.length > 0 ? options[0] : null;
    }
  };

  const MultiValueLabel = (multiProps) => {
    const { data } = multiProps;
    const isInvalid = props.invalidEmails && props.invalidEmails.includes(data.value);
    return (
      <components.MultiValueLabel {...multiProps}>
        <span className={isInvalid ? "text-danger" : ""}>{data.label}</span>
      </components.MultiValueLabel>
    );
  };

  return (
    <CreatableSelect
      isMulti={props.isMulti}
      isSearchable={true}
      closeMenuOnSelect={!props.isMulti}
      onCreateOption={handleCreate}
      formatCreateLabel={email => email}
      isClearable={false}
      classNamePrefix="react-select"
      className="w-100"
      menuPortalTarget={document.body}
      ref={selectRef}
      noOptionsMessage={() => <span>{t('email_select.empty')}</span>}
      options={getOptions()}
      placeholder={t('email_select.placeholder')}
      onBlur={props.onBlur}
      onChange={handleChange}
      value={valueForSelect()}
      components={{ MultiValueLabel }}
    />
  );
};

EmailSelect.defaultProps = {
  value: null,
  isMulti: false,
  isCreateable: false,
  invalidEmails: [],
};

EmailSelect.propTypes = {
  isMulti: PropTypes.bool,
  isCreateable: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.oneOf([null])
  ]),
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  invalidEmails: PropTypes.arrayOf(PropTypes.string),
};

export default EmailSelect;
